@let isLoading = isLoading$ | async;
@let providers = (providers$ | async) ?? [];

<h4>{{ 'INTEGRATIONS_PREFERENCES.CALENDAR_CONTACTS_INTEGRATION' | translate }}</h4>
<mat-divider></mat-divider>
<p>{{ (providers.length > 0 ? 'INTEGRATIONS_PREFERENCES.CALENDAR_CONTACTS_DESCRIPTION_CONNECTED' : 'INTEGRATIONS_PREFERENCES.CALENDAR_CONTACTS_DESCRIPTION') | translate }}</p>

@if (isLoading) {
  <mat-spinner [diameter]="20"></mat-spinner>
} @else if (providers.length > 0) {
  @for (provider of providers; track provider.identity_provider_user_id) {
    <div class="provider-row">
      <img [src]="getProviderIcon(provider) | assetUrl" [alt]="provider.identity_provider_name" class="provider-icon" />
      <div class="provider-info">
        <span class="provider-display-name">{{ provider.display_name }}</span>
        <span class="provider-name">{{ provider.identity_provider_name }}</span>
      </div>
      <button mat-button color="warn" (click)="removeProvider(provider)">
        {{ 'INTEGRATIONS_PREFERENCES.REMOVE_PROVIDER' | translate }}
      </button>
    </div>
  }
} @else {
  <p class="no-providers">{{ 'INTEGRATIONS_PREFERENCES.NO_PROVIDERS' | translate }}</p>
}
